import { Hyperlink } from "@ebsco-ui/ebsco-ui";
import React from "react";
import { FormattedMessage } from "react-intl";
import { EBSCO_URLS } from "../../../../constants";

import messages from "./visit-ebsco-help-link-messages";

import "./visit-ebsco-help-link.scss";

const VisitEbscoHelpLink = props => (
  <Hyperlink
    href={EBSCO_URLS.MERGE_HELP_URL}
    className="visit-ebsco-help-link"
    target="_blank"
  >
    <FormattedMessage {...messages.visitEbscoHelp} />
  </Hyperlink>
);

export default VisitEbscoHelpLink;
